module.exports = __webpack_public_path__ + "img/69.62d2c03e.jpg";